"use client";

import createSvgIcon from "./utils/createSvgIcon.js";
import { jsx as _jsx } from "react/jsx-runtime";
export default createSvgIcon(/*#__PURE__*/_jsx("path", {
  d: "M5.71 12.71c.39.39 1.02.39 1.41 0L12 7.83l4.88 4.88c.39.39 1.02.39 1.41 0s.39-1.02 0-1.41L12.7 5.71a.996.996 0 0 0-1.41 0L5.7 11.3c-.38.38-.38 1.02.01 1.41"
}), 'KeyboardControlKeyRounded');